export default {
    add_stage: "Кезеңді қосыңыз",
    additional: "Қосымша",
    alternative: "Баламалы",
    amount_completed: "Орындалған сома",
    apply_plan_treatment: "Емдеу жоспарын қолдану",
    apply_to_which_teeth: "Қандай тістерге жағу керек",
    apply_treatment_stage_template: "Емдеу қадамының үлгісін қолданыңыз",
    are_you_sure_you_want_to_cancel_plan: "Емдеу жоспарын алып тастағыңыз келетініңізге сенімдісіз бе?",
    by_stages: "Кезеңдер бойынша",
    calls_planning: "Қоңырауларды жоспарлау",
    cancel_plan_treatment: "Емдеу жоспарын тоқтату",
    changes_in_current_stage_were_not_saved: "Ағымдағы қадамдағы өзгерістер сақталмайды",
    choose_criterias_for_fill: "Толтыру үшін қажетті түсіндірмелерді таңдаңыз",
    collapse: "Жыйрату",
    comments: "Түсіндірмелер",
    completed_sum: "Орындалған сома",
    complex_doctor: "Кешен дәрігері",
    'DD.MM.YYYY': "КК.АА.ЖЖЖЖ",
    deadline2: "Мерзімі",
    delete_stage: "Кезеңді жою",
    document_header: "Емдеу жоспарындағы тақырып",
    editing_is_blocked_now_user_is_working: "Өңдеу уақытша қолжетімсіз: {user} қазір жұмыс істейді",
    expand: "Кеңейту",
    grouped: "Топталған",
    grouped_by_services: "Қызметтер бойынша топталған",
    grouped_by_teeth: "Тістер бойынша топталған",
    hide_tooth_formula: "Тіс формуласын жасыру",
    kits_and_materials: "Жинақтар мен материалдар",
    last_update: "Соңғы өзгеріс",
    left: "Солға",
    level_description: "Кезең сипаттамасы",
    main_complaints: "Негізгі шағымдар",
    not_signed: "Қол қойылмаған",
    notification_date: "Хабарлама күні",
    plan: "Жоспар",
    plan_status: "Жоспар күйі",
    plan_treatment_application: "Емдеу жоспарын қолдану",
    plan_treatment_status: "Емдеу жоспарының статусы",
    plan_type: "Жоспар түрі",
    planned_sum: "Жоспарланған сома",
    previous_visits: "Өткен сапарлар",
    quantity: "Саны",
    recommended: "Ұсынылған",
    reset_all: "Барлығын ығыстыру",
    route_list: "Бағыттау парағы",
    save_as_plan_stage_template: "Емдеу қадамының үлгісі ретінде сақтаңыз",
    select_a_doctor_2: "Дәрігерді таңдаңыз",
    select_all: "Барлығын болдырмау",
    select_field: "Бағытты таңдаңыз",
    select_number: "Нөмірді таңдаңыз",
    select_plan: "Жоспарды таңдаңыз",
    select_type: "Түрді таңдаңыз",
    services_selected: "Қызметтер таңдалды",
    show_tooth_formula: "Стоматологиялық формуланы көрсетіңіз",
    sign_without_upload: "Жүктеусіз қол қою",
    signed_at: "Қол қойылды",
    stage_deletion_confirm_text: "Кезең қалпына келтіру мүмкіндігінсіз жойылады. Кез келген сақталмаған өзгертулер жоғалады.",
    stage_doctor: "Сахналық дәрігер",
    stage_title: "Сахна атауы",
    stages_discount: "Кезеңдер бойынша жеңілдік",
    total_sum: "барлық сома",
    treatment_plan_amount: "Емдеу жоспарының сомасы",
    treatment_plan_doctor: "Емдеу жоспарының дәрігері",
    treatment_template_application: "Емдеу үлгісін қолдану",
    which_fields_to_fill: "Қандай өрістерді толтыру керек",
    write_patient_complaints: "Науқастың шағымдарын жазыңыз",
    write_stage_description: "Кезеңге сипаттама жазу"
}
